import { isAuthenticated } from "@/routers/router-guardians"

const routes = [
  {
    path: "/encounter-layout",
    name: "encounter-layout",
    component: () => import("@/layouts/encounter-layout/EncounterLayout.vue"),
    props: (route) => ({ encounterId: route.params.encounterId }),
    children: [
      {
        path: "/dashboard/encounters/:encounterId",
        name: "encounter",
        component: () => import("@/modules/charting/pages/encounter/Encounter.vue"),
        // step/activeChartId arrive via query: Router 4 discards pushed params
        // that aren't part of the route path
        props: (route) => ({
          encounterId: route.params.encounterId,
          step: route.query.step,
          activeChartId: route.query.activeChartId
        }),
        beforeEnter(to, from, next) {
          isAuthenticated(to, from, next)
        }
      }
    ]
  }
]

export default routes
